import { HttpClient } from '../services';
import { SecretManager, CreateSecretManagerPayload, UpdateSecretManagerPayload, GetSecretsResponse } from './types';

class SecretManagerHandlerClass {
    
    GetAllSecretManagers(link: string, callback: (arg0: SecretManager[]) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Get('GetAllSecretManagers', `${link}/secret-managers`, callback, errorHandlerCallback);
    }

    GetSecretManagerById(link: string, id: number, callback: (arg0: SecretManager) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Get('GetSecretManagerById', `${link}/secret-managers/${id}`, callback, errorHandlerCallback);
    }

    GetSecretManagerByName(link: string, name: string, callback: (arg0: SecretManager) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Get('GetSecretManagerByName', `${link}/secret-managers/name/${name}`, callback, errorHandlerCallback);
    }

    CreateSecretManager(link: string, data: CreateSecretManagerPayload, callback: (arg0: SecretManager) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Post('CreateSecretManager', `${link}/secret-managers`, data, callback, errorHandlerCallback);
    }

    UpdateSecretManager(link: string, id: number, data: UpdateSecretManagerPayload, callback: (arg0: SecretManager) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Put('UpdateSecretManager', `${link}/secret-managers/${id}`, data, callback, errorHandlerCallback);
    }

    DeleteSecretManager(link: string, id: number, callback: (arg0: any) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Delete('DeleteSecretManager', `${link}/secret-managers/${id}`, callback, errorHandlerCallback);
    }

    ActivateSecretManager(link: string, id: number,status:string, callback: (arg0: SecretManager) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Put('ActivateSecretManager', `${link}/secret-managers/${id}/${status}`, {}, callback, errorHandlerCallback);
    }

    GetSecrets(link: string, id: number, callback: (arg0: GetSecretsResponse) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Get('GetSecrets', `${link}/secret-managers/${id}/secrets`, callback, errorHandlerCallback);
    }
}

const SecretManagerHandler = new SecretManagerHandlerClass();

export { SecretManagerHandler };
